<template lang="pug">
  div
    div.combo-detail(v-if="rowData.combo.length > 0")
      div.combo-detail--head
        div 藥物名稱
        div.text-center 數量
        div.text-center 刪除
      div.one-med(v-for="pair in rowData.combo")
        div#medication_generic_name {{ pair.medication.generic_name }} 
        div#dose.text-center {{ pair.dose }}
        div#action.text-center
          button.btn.btn-danger.btn-sm(@click="deleteFromControl(pair.relation_id)") 刪除
    
    span 新增藥物至此套藥組
    div.form-inline
      div.search-dynamic(style="width: 100%")
        div.input-group.mr-2
          div.input-group-prepend
            span.input-group-text 藥物
          input.form-control(v-model="searchDrug" placeholder="輸入藥碼, 學名或料位號")
          
        div.input-group.mr-2
          div.input-group-prepend
            span.input-group-text 劑量
          input.form-control(v-model="dose" placeholder="輸入預設劑量" type="number" min="1")
        button.btn.btn-primary(@click="addDrugToControl" :disabled="pairAddable === false") 新增
        div.input-options-wrap(v-show="searchMedicines.length !== 0")
          div.input-option(v-for="med, num in searchMedicines" @click="setMedicine(num)") {{med.code}} - {{med.CGMH_number}} - {{ med.generic_name }}    
</template>

<script>
export default {
  name: 'ControlDetail',
  props: [
    'rowData',
    'rowIndex',
  ],
  data() {
    return {
      searchDrug: '',
      searchMedicines: [],
      addToControlMed: {},
      dose: 1,
    };
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
    pairAddable() {
      if (this.addToControlMed.id === undefined) return false;
      if (this.dose < 1) return false;
      return true;
    },
  },
  methods: {
    setMedicine(index) {
      this.addToControlMed = this.searchMedicines[index];
      this.searchDrug = this.addToControlMed.generic_name;
      this.searchMedicines = [];
    },
    addDrugToControl() {
      this.instance.post('/api/control-medication-set/', {
        parent_medication: this.rowData.medication.id,
        child_medication_quantity: this.dose,
        child_medication: this.addToControlMed.id,
      })
      .then(async () => {
        this.$store.commit('SET_MESSAGE', {
          context: '新增成功',
          type: 'success',
        });
        await this.$parent.$parent.getControlDrugCategory();
        await this.$parent.$parent.getControlSet();
        // hack to let the component reload.
        this.$parent.toggleDetailRow(this.rowIndex + 1);
        this.$parent.toggleDetailRow(this.rowIndex + 1);
      });
    },
    deleteFromControl(id) {
      this.instance.delete(`/api/control-medication-set/${id}/`)
      .then(async (res) => {
        this.$store.commit('SET_MESSAGE', {
          context: '刪除成功',
          type: 'success',
        });
        await this.$parent.$parent.getControlDrugCategory();
        await this.$parent.$parent.getControlSet();
        // hack to let the component reload.
        this.$parent.toggleDetailRow(this.rowIndex + 1);
        this.$parent.toggleDetailRow(this.rowIndex + 1);
      });
    },
  },
  watch: {
    searchDrug(val) {
      if (val.length >= 3 && this.searchDrug !== this.addToControlMed.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val,
          },
        })
        .then((res) => {
          this.searchMedicines = res.data.results;
        });
      } else {
        this.searchMedicines = [];
      }
    },
  },
};
</script>

<style lang="sass">
.combo-detail
  display: table
  width: 95%
  margin: 5px 0 
   

.combo-detail--head
  display: table-header-group
  font-size: 16px
  background-color: rgba(0,0,0,0.1)
  > div
    display: table-cell
    border: 1px solid rgba(0,0,0,0.2)
    padding: 2px 10px

.one-med
  display: table-row
  > div
    display: table-cell
    border: 1px solid rgba(0,0,0,0.2)
    padding: 2px 10px
    font-size: 14px

</style>




// WEBPACK FOOTER //
// ControlDrugDetail.vue?3175db76